import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { safePersistStorage } from '../../../shared/utils/safePersistStorage';
import type {
  NewStrategyWizardActions,
  NewStrategyWizardState,
  WizardMetadata,
} from './types/strategyWizardStoreTypes';

const getInitialMetadata = (user: any | null): WizardMetadata => {
  return {
    name: '',
    code: '',
    currency: 'USD',
    startDate: null,
    endDate: new Date().toISOString().split('T')[0],
    assetClass: 'Public Equity',
    structure: 'Long-Only',
    owners: user ? [user] : [],
    accessLevel: 'Restricted',
    collaborators: [],
    // purpose + reviewFrequency removed — Figma alignment pass.
    agreement: false,
    description: '',
  };
};

export const useNewStrategyWizardStore = create<
  NewStrategyWizardState & NewStrategyWizardActions
>()(
  devtools(
    persist(
      immer((set) => ({
        step: 1,
        isWizardOpen: false,
        selectedArchetype: null,
        metadata: getInitialMetadata(null),

        setIsWizardOpen: (isOpen) =>
          set((state) => {
            state.isWizardOpen = isOpen;
          }),

        setStep: (step) =>
          set((state) => {
            state.step = step;
          }),

        setArchetype: (selectedArchetype) =>
          set((state) => {
            state.selectedArchetype = selectedArchetype;
          }),

        updateMetadata: (data) =>
          set((state) => {
            Object.assign(state.metadata, data);
          }),

        resetWizardStep: () =>
          set((state) => {
            state.step = 1;
            state.isWizardOpen = false;
          }),

        resetWizard: (user: any) =>
          set((state) => {
            state.step = 1;
            state.isWizardOpen = false;
            state.selectedArchetype = null;
            state.metadata = getInitialMetadata(user);
          }),
      })),
      {
        name: 'new-strategy-wizard-store',
        storage: safePersistStorage('session'),
        partialize: (state) =>
          Object.fromEntries(
            Object.entries(state).filter(
              ([key]) =>
                ![
                  'step',
                  'setStep',
                  'isWizardOpen',
                  'setIsWizardOpen',
                ].includes(key),
            ),
          ),
      },
    ),
    {
      name: 'StrategyWizardModal',
    },
  ),
);
